import { createValidator } from 'revalidate';

export default createValidator(
  message => value => {
    if (!value) return message;
  },
  field => `${field} must be true`,
);
